import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

import pkg from './package.json';

export const { version } = pkg;

export { setUpErrorHandling } from './src/error-handler';

export function getAssetsGridFactory(initializeGlobalContext = true) {
  if (initializeGlobalContext) {
    return globalContext.define(
      pkg.legacyDependencies,
      () => import(/* webpackMode: 'eager' */ './src/assets-gridview-factory')
    );
  }
  return import(/* webpackMode: 'eager' */ './src/assets-gridview-factory');
}
